export default "__VITE_PUBLIC_ASSET__95935854__"